import { SimpleGrid as ChakraSimpleGrid, type SimpleGridProps as ChakraSimpleGridProps } from '@chakra-ui/react'
import { forwardRef } from 'react'

export interface Props extends ChakraSimpleGridProps {}

export default forwardRef<HTMLDivElement, Props>((props, ref) => {
  return <ChakraSimpleGrid ref={ref} {...props} />
})